module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.7461/img/storefront-header-blobs.svg"